import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import "./i18n";
import { store } from "./store";

import "./imports";
import App from "./App";
import { ErrorBoundary } from "@sentry/react";
import "mapbox-gl/dist/mapbox-gl.css";
import "./styles/style.scss";
import "typeface-roboto";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import WebglCheck from "WebglCheck";
import { ThemeProvider } from "styled-components";
import theme from "theme";

// The NovusDesignSystem Tooltip writes style.top/left synchronously inside a
// ResizeObserver callback, which causes a resize-feedback loop and a browser
// "ResizeObserver loop completed with undelivered notifications" error.
// Deferring all ResizeObserver callbacks to the next animation frame breaks the
// synchronous layout cycle
const OriginalResizeObserver = window.ResizeObserver;
window.ResizeObserver = class PatchedResizeObserver extends OriginalResizeObserver {
    constructor(callback) {
        super((entries, observer) => {
            requestAnimationFrame(() => callback(entries, observer));
        });
    }
};

ReactDOM.render(
    <Provider store={store}>
        <ErrorBoundary>
            <ThemeProvider theme={theme}>
                <App />
                <WebglCheck />
            </ThemeProvider>
        </ErrorBoundary>
    </Provider>,
    document.getElementById("root")
);

/*
 * If you want your app to work offline and load faster, you can change
 * unregister() to register() below. Note this comes with some pitfalls.
 * Learn more about service workers: https://bit.ly/CRA-PWA
 */
serviceWorkerRegistration.register({
    onUpdate: (registration) => {
        registration.waiting.postMessage({ type: "SKIP_WAITING" });
        window.location.reload();
    }
});
